import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';

const { BaseFilters, UserFilter } = Filters;

const EmailMessageTypeFilter = {
  ...BaseFilters.EnumFilter,
  name: 'messageType',
  label: 'global.type',
  enumNamespace: getEnumNamespace(CoreEnums.EmailMessageType),
  enumSource: CoreEnums.EmailMessageType,
  options: createEnumOptions(CoreEnums.EmailMessageType, 'applications.text.emailType', {
    casing: 'camel',
  }),
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const ProcessInstanceFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'processInstanceId',
  label: 'emailMessageTrace.processInstance',
  knownType: CoreEnums.FormFieldType.InternalEntity,
  apiRoute: 'processInstance/requests/0',
  labelInValue: true,
  params: {
    select: 'id,name',
    orderBy: 'name asc',
  },
};

export const filtersConfig = [
  CreatedDateFilter,
  EmailMessageTypeFilter,
  UserFilter,
  ProcessInstanceFilter,
];

registerModuleFilters('emailMessageTrace', filtersConfig);
